import {iconBoxSizeConfig} from './IconBox';
import {cn} from '../../lib/utils';
import {Skeleton} from '../shadcn/skeleton';

import type {IconBoxSize} from './IconBox';
import type {ComponentProps} from 'react';

export interface IconBoxSkeletonProps extends ComponentProps<'div'> {
  size?: IconBoxSize;
}

/** Loading placeholder for an `IconBox`, sized from the same config the real box uses. */
export function IconBoxSkeleton({className, size = 'md', ...props}: IconBoxSkeletonProps) {
  return (
    <Skeleton
      data-slot="icon-box-skeleton"
      className={cn('shrink-0', iconBoxSizeConfig[size].box, className)}
      {...props}
    />
  );
}
